import get from 'lodash/get';

const DEFAULT_OBJECT = {};

export const getRoutingPathname = state => get(state, 'routing.locationBeforeTransitions.pathname', '');

export const getRoutingSearch = state => get(state, 'routing.locationBeforeTransitions.search', '');

export const getRoutingQuery = state => get(state, 'routing.locationBeforeTransitions.query');

export const getRoutingState = state => get(state, 'routing.locationBeforeTransitions.state', DEFAULT_OBJECT);

export default {
  getRoutingPathname,
  getRoutingSearch,
  getRoutingQuery,
  getRoutingState,
};



// WEBPACK FOOTER //
// ./src/selectors/routingSelectors.js